export default __webpack_public_path__ + "static/media/fallback-image-24b7bcc0763bfbeb00d0e9657eacf602.png";